<div class="details-panel__header panel-header">
  <div class="details-panel__title min-w-0">
    <p appUiLabel class="uppercase tracking-wide">Detalhes</p>
    <p class="mt-0.5 truncate text-sm font-semibold text-ink">{{ conversation()!.company }}</p>
  </div>
  <button
    appUiIconButton
    class="rail-icon-button"
    variant="soft"
    size="md"
    type="button"
    (click)="filters.toggleDetailsPanel()"
    [attr.aria-pressed]="filters.detailsOpen()"
    [attr.aria-label]="filters.detailsOpen() ? 'Fechar detalhes' : 'Abrir detalhes'"
    [title]="filters.detailsOpen() ? 'Fechar detalhes' : 'Abrir detalhes'"
  >
    <ng-icon [name]="filters.detailsOpen() ? 'heroChevronRight' : 'heroInformationCircle'" size="16" aria-hidden="true" />
  </button>
</div>

<div class="details-panel__content min-h-0 overflow-y-auto px-4 pb-4">
  <app-details-panel-content />
</div>
